/**
 * IAN Light Theme — Fluent UI v9 custom theme
 * Extends webLightTheme with IAN brand overrides.
 */
import { webLightTheme } from '@fluentui/react-components';

export const ianLightTheme = {
  ...webLightTheme,

  // Brand (IAN Amber Gold as primary)
  colorBrandBackground: '#FFB500',
  colorBrandBackgroundHover: '#E6A300',
  colorBrandBackgroundPressed: '#CC9200',
  colorBrandBackgroundSelected: '#FFB500',
  colorBrandForeground1: '#FFB500',
  colorBrandForeground2: '#E6A300',
  colorBrandForegroundLink: '#13A3E0',
  colorBrandForegroundLinkHover: '#0D7BAA',
  colorBrandStroke1: '#FFB500',
  colorBrandStroke2: '#E6A300',

  // Surfaces
  colorNeutralBackground1: '#FFFFFF',
  colorNeutralBackground1Hover: '#F0EDE8',
  colorNeutralBackground1Selected: '#FFF5D6',
  colorNeutralBackground2: '#F8F9FA',
  colorNeutralBackground3: '#F0F1F3',
  colorNeutralCardBackground: '#FFFFFF',
  colorNeutralCardBackgroundHover: '#FFFFFF',

  // Text
  colorNeutralForeground1: '#0B111A',
  colorNeutralForeground2: '#4A4F57',
  colorNeutralForeground3: '#6E747D',
  colorNeutralForegroundDisabled: '#A0A5AD',
  colorNeutralForegroundOnBrand: '#0B111A',

  // Borders
  colorNeutralStroke1: '#E0E2E6',
  colorNeutralStroke2: '#C8CBD0',
  colorStrokeFocus2: '#13A3E0',

  // Semantic
  colorPaletteRedBackground1: '#FFF0F0',
  colorPaletteRedForeground1: '#FF5757',
  colorPaletteGreenBackground1: '#F0FAF0',
  colorPaletteGreenForeground1: '#7ED956',
  colorPaletteYellowBackground1: '#FFF8E6',
  colorPaletteYellowForeground1: '#FFB500',

  // Compound brand (toggles, checkboxes)
  colorCompoundBrandBackground: '#FFB500',
  colorCompoundBrandBackgroundHover: '#E6A300',
  colorCompoundBrandBackgroundPressed: '#CC9200',
  colorCompoundBrandForeground1: '#FFB500',
  colorCompoundBrandStroke: '#FFB500',

  // Subtle
  colorSubtleBackground: 'transparent',
  colorSubtleBackgroundHover: '#F0EDE8',
  colorSubtleBackgroundPressed: '#E8E4DD',
  colorSubtleBackgroundSelected: '#FFF5D6',

  // Typography
  fontFamilyBase: "'Avenir Next LT Pro', 'Avenir Next', 'Avenir', 'Segoe UI', 'Helvetica Neue', sans-serif",

  // Shadows
  shadow2: '0 1px 2px rgba(11,17,26,0.06)',
  shadow4: '0 2px 4px rgba(11,17,26,0.06)',
  shadow8: '0 4px 8px rgba(11,17,26,0.08)',
  shadow16: '0 8px 16px rgba(11,17,26,0.10)',
  shadow28: '0 8px 24px rgba(11,17,26,0.12)',
  shadow64: '0 16px 48px rgba(11,17,26,0.16)',
};

export default ianLightTheme;
